const isStripePaymentFailed = (response) => {
  if (!response || response?.error) return true;

  if (response?.tokenExpired) return false;

  return (
    response?.status === "failed" ||
    (response?.status && response?.status !== "succeeded") ||
    response?.statusCode === 402 ||
    response?.statusCode === 400 ||
    response?.type === "StripeCardError" ||
    response?.type === "StripeInvalidRequestError" ||
    response?.rawType === "card_error" ||
    response?.rawType === "invalid_request_error" ||
    response?.code === "card_declined" ||
    Boolean(response?.raw?.message)
  );
};

const getStripePaymentErrorMessage = (response) => {
  if (!response) {
    return "Payment failed. Please try again.";
  }

  if (typeof response?.message === "string" && response.message) {
    return response.message;
  }

  if (response?.raw?.message) {
    return response.raw.message;
  }

  if (response?.code) {
    return response.code.replace(/_/g, " ");
  }

  return "Payment failed. Please try again.";
};

const isStripePaymentSucceeded = (response) =>
  response?.status === "succeeded";

export {
  isStripePaymentFailed,
  isStripePaymentSucceeded,
  getStripePaymentErrorMessage,
};
